const FALLBACK_PROD =
  "https://api-vps.yumesaku.tech";
const FALLBACK_DEV = "http://localhost:8090";
const BROWSER_RELATIVE_FALLBACK = ""; // Use same-origin /api/* via React Router action

const isAbsoluteUrl = (value?: string) =>
  !!value && /^https?:\/\//i.test(value.trim());

const resolveNodeFallback = () =>
  typeof process !== "undefined" && process.env?.NODE_ENV === "production"
    ? FALLBACK_PROD
    : FALLBACK_DEV;

const resolveRuntimeEnvValue = (...keys: string[]) => {
  // SSR/Node 環境
  if (typeof process !== "undefined" && process.env) {
    for (const key of keys) {
      const value = process.env[key];
      if (value) return value;
    }
  }

  // ブラウザ環境（Vite 等で注入される window.__ENV__ を想定）
  if (typeof globalThis !== "undefined") {
    const runtimeEnv =
      (globalThis as any).__APP_CONFIG__ || (globalThis as any).__ENV__;
    if (runtimeEnv) {
      for (const key of keys) {
        const value = runtimeEnv[key];
        if (value) return value;
      }
    }
  }

  return undefined;
};

const resolveRuntimeApiUrl = () => {
  const runtimeValue = resolveRuntimeEnvValue(
    "API_URL",
    "VITE_API_BASE_URL",
    "PUBLIC_API_URL"
  );

  if (runtimeValue) {
    return runtimeValue;
  }

  // On the browser we prefer routing through our own /api action so that
  // authentication requests always go via the Cloudflare Worker proxy.
  if (typeof document !== "undefined") {
    return BROWSER_RELATIVE_FALLBACK;
  }

  return resolveNodeFallback();
};

const resolveProxyTargetUrl = (env?: { API_URL?: string }) => {
  if (isAbsoluteUrl(env?.API_URL)) {
    return env!.API_URL!;
  }

  const runtimeValue = resolveRuntimeEnvValue(
    "API_URL",
    "VITE_API_BASE_URL",
    "PUBLIC_API_URL"
  );

  if (isAbsoluteUrl(runtimeValue)) {
    return runtimeValue!;
  }

  return resolveNodeFallback();
};

// API設定の一元管理
export const apiConfig = {
  // 本番APIのURL
  productionApiUrl: FALLBACK_PROD,

  // 開発環境のAPI URL
  developmentApiUrl: FALLBACK_DEV,

  // 環境に応じたAPI URLを取得
  getApiUrl: () => resolveRuntimeApiUrl(),

  // プロキシ用のAPI URLを取得
  getProxyTargetUrl: (env?: { API_URL?: string }) => {
    return resolveProxyTargetUrl(env);
  },
};
